import envValues from './env';

export default function (valuePath, defaultValue = null) {
    var splits = valuePath.split('.');
    var value = envValues;

    for (var i = 0; i < splits.length; i++) {
        value = value[splits[i]];
    }

    return value ? value : defaultValue;
}


// WEBPACK FOOTER //
// ./resources/assets/js/config.js